import { generateClient } from "aws-amplify/api";
import { createTypeCounter, updateTypeCounter } from "graphql/customs/mutations";
import { getTypeCounter as fetchTypeCounter, listTypeCounters } from "graphql/queries";
import { cleanUpData, getDataFromResponse, getNotDeletedItems } from "utils/Api";

const API = generateClient();

export const saveTypeCounter = (data) => {
    const operationName = (data && data.id) ? "update" : "create";
    const operation = operationName === "update" ? updateTypeCounter : createTypeCounter;
    return API.graphql({
        query: operation,
        variables: {
            "input": cleanUpData(data)
        }
    })
};

export const increaseTypeCounter = (typeCounter) => {
    const newTypeCounter = {
        ...typeCounter,
        count: typeCounter.count + 1
    }

    return API.graphql({
        query: updateTypeCounter,
        variables: {
            "input": cleanUpData(newTypeCounter)
        }
    })
};

export const getTypeCounters = async (filter = {}) => {
    const data = await API.graphql({
        query: listTypeCounters,
        variables: {
            "filter": filter
        }
    })
    return getNotDeletedItems(data, "listTypeCounters");
}

export const getTypeCounterByName = async (counterName) => {
    const data = await API.graphql({
        query: listTypeCounters,
        variables: {
            "filter": {
                "type": { "eq": counterName }
            }
        }
    })
    const counters = getNotDeletedItems(data, "listTypeCounters");
    if (counters.length === 0) {
        const counterObj =  await saveTypeCounter({
            type: counterName,
            count: 0
        });
        return getDataFromResponse(counterObj, "createTypeCounter");
    } else {
        return counters[0];
    }
}


export const getTypeCounter = async (typeId) => {
    let typeCounterObj = await API.graphql({
        query: fetchTypeCounter,
        variables: {
            id: typeId
        }
    });
    return getDataFromResponse(typeCounterObj, "getTypeCounter");
}